import { render, staticRenderFns } from "./PreOrderHeader.vue?vue&type=template&id=10cfce22&scoped=true&"
import script from "./PreOrderHeader.vue?vue&type=script&lang=js&"
export * from "./PreOrderHeader.vue?vue&type=script&lang=js&"
import style0 from "./PreOrderHeader.vue?vue&type=style&index=0&id=10cfce22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cfce22",
  null
  
)

export default component.exports